import React from "react";
import YouTube from 'react-youtube';
import ReactPlayer from 'react-player/vimeo'
import { observer, inject } from "mobx-react";
import { observable } from "mobx";
import YotpoReviewCarousel from "@components/Yotpo/YotpoReviewCarousel";

@inject("store")
@observer
export default class DocTypeYotpoReviewCarousel extends React.Component {
    constructor(props) {
        super(props);
        //this.ref = Math.random().toString(36).substr(2, 9);
    }

    render() {
        let modes = {"Top Rated":"top_rated", "Most Recent": "most_recent"};
        let types = {"Site Reviews":"site", "Site & Product Reviews": "both", "Product Reviews - All Products":"product"};
        
        let mode = modes[this.props.model.mode||"Top Rated"];
        let type = types[this.props.model.type||"Site & Product Reviews"];
        let count = this.props.model.count;
        let showBottomLine = this.props.model.showBottomLine;
        let showNavigation = this.props.model.showNavigation;
        let autoPlay = this.props.model.autoPlay;
        let autoPlaySpeed = this.props.model.autoPlaySpeed;

        let headerEnabled = this.props.model.headerCustomisationEnabled;
        let headerColor = this.props.model.headerColor;
        let headerSize = this.props.model.headerFontSize;
        let headerText = this.props.store.navigation.dictionary[this.props.model.headerText] || this.props.model.headerText;
        let headerAlignCenter = this.props.model.headerAlignCenter;
        
        return (<YotpoReviewCarousel 
            mode={mode} 
            type={type} 
            count={count} 
            showBottomLine={showBottomLine} 
            showNavigation={showNavigation} 
            autoPlay={autoPlay} 
            autoPlaySpeec={autoPlaySpeed}
            headerEnabled={headerEnabled}
            headerColor={headerColor}
            headerSize={headerSize}
            headerText={headerText}
            headerAlignCenter={headerAlignCenter}
        />);
    }
}